import { default as invoiceMinus } from "../../../icons/invoiceMinus.svg";

import React, {useEffect, useState} from "react";
import "../InvoicePage.scss";
import { Returntext } from "../../Landings/common/returnText";
import { useContent, useLanguages } from "../../../hooks/content";

function InvoiceSellerComponent({ props }) {
    const { lang } = useLanguages();
    const { contentManagementData } = useContent();
    const [data, setData] = useState([]);

    useEffect(() => {
        const result = props.map(data => {
            return {
                location: data.address,
                tracking: { key: data.name },
                phone: {
                    key: Returntext(contentManagementData, 'poi_content_service_providers_phone', lang),
                    value: data.phone
                },
                email: {
                    key: Returntext(contentManagementData, 'poi_content_service_providers_email', lang),
                    value: data.email
                },
                id: {
                    key: Returntext(contentManagementData, 'poi_content_service_providers_id', lang),
                    value: data.id
                },
            }
        })

        setData(result)
    }, [lang])

    return (
        <div className='invoice-sheet'>
            <div className="invoice-title">
                <span>{ Returntext(contentManagementData, 'poi_sheet_title_service_providers', lang) }</span>
                <img src={invoiceMinus} alt="minus"/>
            </div>
            <div className="invoice-sheet-container">
                {
                    data.map((item, index) => {
                        return (
                            <div className="invoice-content-item" key={index}>
                                <div className="invoice-item tracking">
                                    <div> { item?.tracking.key } </div>
                                    <div> { item?.tracking.value } </div>
                                </div>
                                <div className="invoice-item location">
                                    <div> { item?.location } </div>
                                </div>
                                <div className="invoice-item">
                                    <div>{ item?.phone.key }</div>
                                    <div>{ item?.phone.value }</div>
                                </div>
                                <div className="invoice-item">
                                    <div> { item?.email.key } </div>
                                    <div> { item?.email.value } </div>
                                </div>
                                <div className="invoice-item">
                                    <div> { item?.id.key } </div>
                                    <div> { item?.id.value } </div>
                                </div>
                            </div>
                        )
                    })
                }
            </div>

        </div>
    )
}

export default InvoiceSellerComponent;